import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useCharger, api } from "./charger";
import { Chargement, Erreur, Titre } from "./ui";

/* Mes outils (24/10/2026, demande d'alex : « qu'Adrien puisse intégrer ses outils à lui ») :
   chaque membre de l'équipe range ici ses propres liens (agenda, téléphonie, tableur, LinkedIn…).
   Personne d'autre ne les voit. Stockés dans utilisateurs.outils (server/routes-crm.ts, /api/crm/mes-outils). */
type Outil = { titre: string; url: string; note?: string };

export function OutilsPage() {
  const { data, erreur, recharger } = useCharger<{ outils: Outil[] }>("/api/crm/mes-outils");
  const [f, setF] = useState<Outil>({ titre: "", url: "", note: "" });
  const [msg, setMsg] = useState("");
  if (erreur) return <div className="p-6"><Erreur message={erreur} /></div>;
  if (!data) return <div className="p-6"><Chargement /></div>;
  const enregistrer = async (outils: Outil[]) => {
    setMsg("");
    try { await api.put("/api/crm/mes-outils", { outils }); recharger(); } catch (e) { setMsg((e as Error).message); }
  };
  const ajouter = async () => {
    if (!f.titre.trim() || !/^https?:\/\//i.test(f.url.trim())) { setMsg("Il faut un titre et une adresse qui commence par https://"); return; }
    await enregistrer([...data.outils, { titre: f.titre.trim(), url: f.url.trim(), note: f.note?.trim() || undefined }]);
    setF({ titre: "", url: "", note: "" });
  };
  return (
    <div className="mx-auto max-w-5xl space-y-6 p-6">
      <Titre sous="Vos liens à vous : agenda, téléphonie, tableur, LinkedIn… Personne d'autre ne les voit.">Mes outils</Titre>
      {data.outils.length === 0 ? <p className="text-sm text-muted-foreground">Aucun outil pour l'instant. Ajoutez le premier ci-dessous.</p> : (
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
          {data.outils.map((o, i) => (
            <div key={i} className="flex flex-col gap-1 rounded-md border bg-card p-4">
              <a className="text-base font-semibold underline-offset-2 hover:underline" href={o.url} target="_blank" rel="noreferrer">{o.titre} ↗</a>
              <p className="truncate text-xs text-muted-foreground">{o.url}</p>
              {o.note && <p className="text-sm">{o.note}</p>}
              <button type="button" className="mt-1 self-start text-xs underline" onClick={() => enregistrer(data.outils.filter((_, j) => j !== i))}>Retirer</button>
            </div>
          ))}
        </div>
      )}
      <div className="max-w-xl space-y-3 rounded-md border bg-card p-4">
        <p className="font-semibold">Ajouter un outil</p>
        <Input value={f.titre} onChange={(e) => setF({ ...f, titre: e.target.value })} placeholder="Titre (Mon agenda)" aria-label="Titre" />
        <Input value={f.url} onChange={(e) => setF({ ...f, url: e.target.value })} placeholder="https://…" aria-label="Adresse" />
        <Input value={f.note || ""} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="Note (facultatif)" aria-label="Note" />
        {msg && <Erreur message={msg} />}
        <Button type="button" onClick={ajouter}>Ajouter</Button>
      </div>
    </div>
  );
}
